import React from "react";
import HeatmapNeighborsTimeSeriesChart from "./HeatmapNeighborsTimeSeriesChart";

const IFRAME_HEIGHT = 870;

const HeatmapChart = () => {
    const API_URL = process.env.REACT_APP_API_URL || "";

    return (
        <div style={{ width: '100%', display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            {/* Heatmap explorer — flex-shrinks so the image inside scales down */}
            <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                <iframe
                    src={`${API_URL}/data/heatmap-explorer`}
                    title="Hedging Cost Heatmap Explorer"
                    scrolling="no"
                    style={{
                        width: '100%',
                        height: `${IFRAME_HEIGHT}px`,
                        border: 'none',
                        borderRadius: '4px',
                        overflow: 'hidden',
                    }}
                />
            </div>

            {/* Price vs neighbors — fixed-width panel filling the right whitespace */}
            <div style={{ flex: '0 0 360px' }}>
                <div style={{ fontSize: '12px', color: '#666', textAlign: 'center', marginBottom: '4px', fontWeight: 500 }}>
                    SPX Price vs Heatmap Neighbors
                </div>
                <HeatmapNeighborsTimeSeriesChart chartHeight="600px" />
            </div>
        </div>
    );
};

export default HeatmapChart;
